module.exports = __webpack_public_path__ + "assets/img/logo-black.d23059ef.png";